<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-produto"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoInput"
                        title="situacao"
                        :options="situacoes"
                        :mlLabels="true"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :height="40"
                        :clearable="true"
                    />
                </div>
                <!-- BOTÃO DE VÍNCULO -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModal = !showModal"
                    >
                        {{ $t('vincular-produto') }}
                    </button>
                </div>
                <!-- Botao vai para a tela de cadastro de produto, e a função para 
                voltar para a tela atual está na OcorrenciaManage e Geral de produto -->
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-produto-new',
                                query: {
                                    tela: `${abrev}-cultura-edit`,
                                    id: $route.params.id,
                                    descricao: $route.params.descricao,
                                    contexto: $route.meta.contexto,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>
            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assTipoCulturaProduto"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row[f.key] == 1"
                                type="is-success"
                                size="is-medium"
                            >
                                {{ $t('ativo') }}
                            </b-tag>
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                            >
                                {{ $t('inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span v-if="permissao.update && !assTipoCulturaProdutoIntegracao">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModal">
                <div class="bg">
                    <ProdutoModal :idtipocultura="idtipocultura" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTipoCulturaProdutoService from '@/services/agro/cultura/AssTipoCulturaProdutoService';
import ProdutoModal from '@/components/agro/cultura/modal/ProdutoModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/* @71146 - Cadastro de cultura- Aba produto */
export default {
    components: {
        ContainerLoader,
        ProdutoModal,
    },
    props: {
        idtipocultura: 0,
    },
    data() {
        return {
            assTipoCulturaProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTIPOCULTURAPRODUTO'
            ),
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRODUTO'),
            assTipoCulturaProduto: [],
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'grupoproduto', width: null, sortable: true, sortFn: null },
                { key: 'subgrupoproduto', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            service: new AssTipoCulturaProdutoService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'produto',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            permissaoCadastroProduto: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            (this.abrev = this.$route.meta.contexto.slice(0, 4)),
                (this.permissao = this.hasPermissionAccess(
                    'agro',
                    'agro-cadastros',
                    'agro-cultura'
                ));
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
        }

        //verificar permissão da página de produto para controlar o botão de adicionar
        this.permissaoProduto = this.hasPermissionAccess('vendas', 'vendas', 'venda-produtos');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-cultura` },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }

        // retirar && false quando tiver página de produto
        this.permissaoVincular = this.permissao.create && !this.assTipoCulturaProdutoIntegracao;
        this.permissaoCadastrar = this.permissaoProduto.create && !this.produtoIntegracao;
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.idtipocultura,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assTipoCulturaProduto = value;
                    this.isEmpty = this.assTipoCulturaProduto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de produto.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.idasstipoculturaproduto,
                    codigo: m.produto.idprodutoerp,
                    idtipocultura: m.idtipocultura,
                    idproduto: m.produto.idproduto,
                    descricao: m.produto.descricao,
                    grupoproduto: m.produto.grupoproduto.descricao,
                    subgrupoproduto: m.produto.subgrupoproduto.descricao,
                    excluir: 'excluir',
                    situacao: m.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        removePrompt() {
            this.delete = null;
        },
        onSearch(value) {
            this.queryFilter = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-sucesso-ao-reativar-associacao-produto'
                    : 'msg-sucesso-ao-desativar-associacao-produto';

            let tempasstipoculturaproduto = {
                idasstipoculturaproduto: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempasstipoculturaproduto, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-produto'
                                : 'msg-sucesso-ao-desativar-associacao-produto';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        fecharModal() {
            this.showModal = false;
            this.carregarDados();
        },
        cadastrado() {
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
